/** Max note lengths: the note fields do not take more (`maxLength`), so a longer note cannot be sent. */
export const ORDER_NOTE_MAX_LENGTH = 4000;
export const ORDER_INTERNAL_NOTE_MAX_LENGTH = 4000;

export const ORDER_NOTE_MAX_LENGTHS = {
  note: ORDER_NOTE_MAX_LENGTH,
  internalNote: ORDER_INTERNAL_NOTE_MAX_LENGTH,
} as const;
